import { render, staticRenderFns } from "./IcoCpdContent.vue?vue&type=template&id=643912e3"
import script from "./IcoCpdContent.vue?vue&type=script&lang=js"
export * from "./IcoCpdContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports